import { TerminationActionTypes } from './constants';

const INIT_STATE = {
    data: null,
    loading: false,
    error: null,
    updateSuccess: null,
    submitSuccess: null,
};

const Termination = (state = INIT_STATE, action) => {
    switch (action.type) {
        case TerminationActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TerminationActionTypes.GET_TERMINATION:
                    return { ...state, data: action.payload.data, loading: false };
                case TerminationActionTypes.SUBMIT_TERMINATION:
                    return {
                        ...state,
                        id: action.payload.id,
                        data: action.payload.data,
                        loading: false,
                        submitSuccess: true,
                    };
                case TerminationActionTypes.CONFIRM_TERMINATION:
                    return {
                        ...state,
                        id: action.payload.id,
                        data: action.payload.data,
                        loading: false,
                        submitSuccess: true,
                    };
                case TerminationActionTypes.RETRACT_TERMINATION:
                    return {
                        ...state,
                        id: action.payload.id,
                        data: action.payload.data,
                        loading: false,
                        retractSuccess: true,
                    };
                default:
                    return { ...state };
            }
        case TerminationActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TerminationActionTypes.GET_TERMINATION:
                    return { ...state, error: action.payload, loading: false };
                case TerminationActionTypes.SUBMIT_TERMINATION:
                    return { ...state, error: action.payload, loading: false, submitSuccess: false };
                case TerminationActionTypes.CONFIRM_TERMINATION:
                    return { ...state, error: action.payload, loading: false, submitSuccess: false };
                case TerminationActionTypes.RETRACT_TERMINATION:
                    return { ...state, error: action.payload, loading: false, retractSuccess: false };
                default:
                    return { ...state };
            }
        case TerminationActionTypes.GET_TERMINATION:
            return { ...state, data: null, loading: false };
        case TerminationActionTypes.SUBMIT_TERMINATION:
            return { ...state, data: null, loading: false };
        case TerminationActionTypes.CONFIRM_TERMINATION:
            return { ...state, data: null, loading: false };
        case TerminationActionTypes.RETRACT_TERMINATION:
            return { ...state, data: null, loading: false };
        case TerminationActionTypes.RESET_TERMINATION:
            return INIT_STATE;
        default:
            return { ...state };
    }
};

export default Termination;
